import { Component, OnInit } from '@angular/core';
import {default as _} from 'lodash';
import { CommonModule } from '@angular/common';
import { EmitterService } from 'app/Shared/Services/emitter.service';
import { ConstantService } from 'app/Shared/Services/constant-service';
import { UserService } from 'app/Shared/Services/user.service';
import { FilterPanelComponent } from 'app/Shared/Component/filter-panel/filter-panel.component';
import { FinraRegInquiryListComponent } from 'app/Pages/reg-inquiry/finra-inquiry/finra-reg-inquiry-list/finra-reg-inquiry-list.component';
import { default as InquiryGridColumnsJSON } from 'app/Pages/reg-inquiry/inquiry-list-column.json';
import { default as CATROEGridColumnsJSON } from 'app/Shared/Constant/Grid Column Names/CAT-ROE-Viewer-Columns.json';
import { TabsModule } from 'primeng/tabs';
import { FinraInquiryServiceService } from 'app/Pages/reg-inquiry/finra-inquiry/finra-inquiry-service.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
    selector: 'app-finra-inquiry',
    imports: [CommonModule, TabsModule, FilterPanelComponent, FinraRegInquiryListComponent],
    templateUrl: './finra-inquiry.component.html',
    styleUrls: ['./finra-inquiry.component.scss']
})
export class FinraInquiryComponent implements OnInit {
  isOpenDialog: boolean = false;
  // Inititalize Inquiry Grid Columns
  InquiryGridColumns: any = InquiryGridColumnsJSON["reg_inquiry_Columns"];
  InquiryFilterGridColumns: any = this.InquiryGridColumns.filter((gridRowObj: any) => (!_.includes(['Action'], gridRowObj.ui_columnname) && gridRowObj.display !== "false"));

  // Inititalize CAT-ROE Grid Columns
  CATROEGridColumns: any = CATROEGridColumnsJSON["CAT-ROE-Grid-Columns"];
  CATROEFilterGridColumns: any = this.CATROEGridColumns.filter((gridRowObj: any) => (!_.includes(['Action'], gridRowObj.ui_columnname) && gridRowObj.display !== "false"));

  filterPanelGridColumns: any = [];
  pageName: any = "Reg-Inquiry-List";
  defaultFilterArray: any = [];
  RegInquiryDefaultFilterArray: any = [];
  LastExecutionInquiryDate!: any[];

  constructor(private emitterService: EmitterService,
    private UserService: UserService,
    public constantService: ConstantService,
    public FinraInquiryServiceService: FinraInquiryServiceService) { }

  ngOnInit() {
    this.isOpenDialog = false;
    // Call Service functions for Default and Add Inquiry Dialogbox Fields
    this.FinraInquiryServiceService.defaultFilter();
    this.FinraInquiryServiceService.InquiryFilter();

    // Update FilterArray with Prefix DB Table aliases for Search purposes
    this.upgradeFilterFieldArray(this.InquiryFilterGridColumns, "ui_columnname", "ui_columnname", "db_columnname");

    this.defaultFilter();
  }

  upgradeFilterFieldArray(originalFilterArr: any, searchField: any, compareFieldName: any, updateField: any) {
    for(let i=0; i<originalFilterArr.length; i++) {
      if(InquiryGridColumnsJSON["inquiry_Columns"].filter((rowObj: any) => rowObj[searchField]===originalFilterArr[i][compareFieldName]).length > 0) {
        if(_.includes(['File_Name'], originalFilterArr[i][updateField])) {
          originalFilterArr[i][updateField] = "tcflh." + originalFilterArr[i][updateField];
        } else {
          originalFilterArr[i][updateField] = "ti." + originalFilterArr[i][updateField];
        }
      } else if(InquiryGridColumnsJSON["query_form_columns"].filter((rowObj: any) => rowObj[searchField]===originalFilterArr[i][compareFieldName]).length > 0) {
        originalFilterArr[i][updateField] = "tiq." + originalFilterArr[i][updateField];
      } else if(InquiryGridColumnsJSON["inquiry_result_Columns"].filter((rowObj: any) => rowObj[searchField]===originalFilterArr[i][compareFieldName]).length > 0) {
        originalFilterArr[i][updateField] = "tiqr." + originalFilterArr[i][updateField];
      }
    }
  }

  clickFinraInquiryTab(selectedTabName: any) {
    this.pageName = selectedTabName;
  }

  defaultFilter() {
    // Update FilterArray for Search purposes
    this.upgradeFilterFieldArray(this.FinraInquiryServiceService.DefaultFilterArray, "db_columnname", "columnname", "columnname");

    this.defaultFilterArray = this.FinraInquiryServiceService.DefaultFilterArray;

    this.RegInquiryDefaultFilterArray = this.FinraInquiryServiceService.DefaultFilterArray;
  }

  filterApplyFilterEvent(event: any) {
    if(typeof event === 'object' && !Array.isArray(event) && event !== null && event.Action==="AddedInquiry") {
        this.FinraInquiryServiceService.userAction = event.Action; // Save User Action (e.g. Add/Edit Inquiry)
        this.FinraInquiryServiceService.resetInquiryFilter(); // Reset Add Inquiry Filter 

        // Assign Inquiry Filter Grid Columns
        this.filterPanelGridColumns = this.InquiryFilterGridColumns;

        this.RegInquiryDefaultFilterArray[0].values = [event.updatedInquiryDate, event.updatedInquiryDate];
        this.defaultFilterArray = [...this.RegInquiryDefaultFilterArray];

        this.refreshScreen();
    } else {
      this.FinraInquiryServiceService.userAction = ""; // Reset User Action
      this.defaultFilterArray = [];
      this.defaultFilterArray = event;

      this.RegInquiryDefaultFilterArray = [];
      this.RegInquiryDefaultFilterArray = event;
    }
  }

  fetchRequestedFilter(event: any) {
    this.isOpenDialog = false;
    this.FinraInquiryServiceService.modifiednquiryRowObj = new Object(); // Reset Modified Object while Operating Non-Edit Popup
    this.FinraInquiryServiceService.userAction = "";

    if(event === "Add-Inquiry-Dialog") {
      // Assign CAT ROE Filter Grid Columns
      this.filterPanelGridColumns = this.CATROEFilterGridColumns;

      // Assign Inquiry Status while Add Inquiry (e.g. - Initiated) by checking Inquiry Result Execution Privilege condition
      let InquiryStatusIndex = this.FinraInquiryServiceService.InquiryFilterArray.findIndex((filterElem: { columnname: string; }) => filterElem.columnname === 'status');
      this.FinraInquiryServiceService.InquiryFilterArray[InquiryStatusIndex]["values"] = this.constantService["inquirySelectionValues"][0]["inquiryFields"]["status"][0];

      this.defaultFilterArray = [...this.FinraInquiryServiceService.InquiryFilterArray];
    } else if(event === "Default-Filter-Dialog") {
      // Assign Inquiry Filter Grid Columns
      this.filterPanelGridColumns = this.InquiryFilterGridColumns;

      this.defaultFilterArray = [...this.RegInquiryDefaultFilterArray];
    }
  }

  editInquiryDetail(event: any) {

    this.isOpenDialog = true;
    // Assign CAT ROE Filter Grid Columns
    this.filterPanelGridColumns = this.CATROEFilterGridColumns;

    this.FinraInquiryServiceService.modifiednquiryRowObj = event; // Assign Selected Inquiry Detail as Modified Object while Operating Edit Popup

    const filterData = JSON.parse(event.inquiryDetail); // Extract Inquiry Filter for Edit Inquiry Filer Detail

    // Assign Inquiry Status while Edit Inquiry (e.g. - Modified | Re-initiated) by checking Inquiry Result Execution Privilege condition
    let InquiryStatusIndex = filterData.findIndex((filterElem: { columnname: string; }) => filterElem.columnname === 'status');

    if(_.includes(["Deleted"], this.FinraInquiryServiceService.modifiednquiryRowObj.status)) {
      filterData[InquiryStatusIndex]["values"] = this.constantService["inquirySelectionValues"][0]["inquiryFields"]["status"][3];
    } else {
      filterData[InquiryStatusIndex]["values"] = this.constantService["inquirySelectionValues"][0]["inquiryFields"]["status"][1];
    }

    this.defaultFilterArray = [...filterData];

  }

  // Reload Finra Inquiry Result Screen
  refreshScreen(event?: any) {
    this.defaultFilterArray = [...this.defaultFilterArray];

    this.RegInquiryDefaultFilterArray = [...this.RegInquiryDefaultFilterArray];
  }

}